import React, {useRef} from 'react';

import classNames from 'classnames';
import {observer} from 'mobx-react';
import MaskedInput from 'react-text-mask';

import {InputPropsCommon} from './Input';
import styles from './Input.module.scss';
import {scrollToInput} from '../../helpers/scrollToInput';

export type maskFunc = (val: string) => (string | RegExp)[];

export type mask = string[] | maskFunc | Array<RegExp | string>;

interface InputMaskedProps extends InputPropsCommon {
    mask?: mask;
    className?: string;
    name?: string;
}

const defaultPhoneMask = ['(', /[2-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

const InputMasked: React.FC<InputMaskedProps> = ({
    value,
    onChange,
    placeholder,
    disabled,
    name,
    error,
    type,
    border,
    mask,
    labelRight,
    ariaLabel,
    noLimit,
    className,
    onBlur,
    onFocus,
}) => {
    const container = useRef<HTMLDivElement>();
    const maskSchema = type === 'tel' ? defaultPhoneMask : mask;

    return (
        <div
            ref={container}
            className={classNames(
                styles.Input,
                !!error && styles.error,
                !!border && styles.border,
                noLimit && styles.noLimit,
                className,
            )}
        >
            <MaskedInput
                type={type}
                aria-label={ariaLabel}
                value={value}
                name={name}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
                onFocus={(e) => {
                    scrollToInput(e.target);
                    if (onFocus) {
                        onFocus(e);
                    }
                }}
                placeholder={placeholder || ''}
                disabled={disabled}
                mask={maskSchema || false}
                guide={false}
            />
            <div className={styles.labelRight}>
                <p className="subTitle">{labelRight}</p>
            </div>
            {!!error && <div className={styles.errorMessage}>{error}</div>}
        </div>
    );
};

export default observer(InputMasked);
